import { combineReducers } from 'redux';
import Settings from './Settings';
import Auth from './Auth';
import ChatRoom from './ChatRoom';
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'

export default combineReducers({
    Settings,
    Auth,
    ChatRoom,
    firestore: firestoreReducer,
    firebase: firebaseReducer
});
